import React from 'react';
import DiscountModal from './components/DiscountModal';

const PosDiscountsView = () => (
  <div className="container py-4">
    <h1 className="h3 fw-bold mb-1">Remises POS</h1>
    <p className="text-muted">Vue séparée pour la gestion des remises POS.</p>
    <DiscountModal />
  </div>
);

export default PosDiscountsView;
